import React, {useState} from 'react';
import { Icon } from 'antd';
import MapType from './MapType';
import OpacitySlider from './OpacitySlider';
import { Link } from "react-router-dom";

const Setting = () => {
  const [minimise, onMinimise] = useState(true)

  const onUpdate = (e) => {
    e.preventDefault();
    onMinimise(!minimise)
  }

  return (
    <div className={ minimise ? 'setting': 'setting expand'}>
      { minimise ? 
        <Link aria-label="Setting" to="/" onClick={onUpdate}>
          <Icon type="setting"/>
        </Link> :
        <div>
          <MapType onUpdate={onUpdate}/>
          <OpacitySlider />
        </div>
    }
    </div>
  )
}
export default Setting;




// WEBPACK FOOTER //
// ./src/components/Setting.js